/**
 * Main export file for image export utilities
 * Re-exports all functions for backward compatibility
 */

// Core image export functions
/**
 * Downloads a full image (backward compatibility)
 */
import { exportImage, downloadImageFromDataUrl } from './export-image-core';

// PDF export functions
export type { FrameObject } from './export-image-pdf';
// Position-based export functions
export { exportImagePosition } from './export-image-position';
export type { IExportFrameProps } from './export-image-frame';

export type { ImagePositionOptions } from './export-image-position';
// Frame export functions
export { exportFrame, downloadImageFrame } from './export-image-frame';

export { exportPdfFrame, exportPdfFrameAsBlob } from './export-image-pdf';
export { exportImage, downloadImageFromDataUrl } from './export-image-core';

export async function downloadImage({
  element,
  projectName,
  pixelRatio = 4,
}: {
  element: HTMLElement;
  projectName: string;
  pixelRatio: number;
}): Promise<void> {
  const dataUrl = await exportImage({ element, pixelRatio });
  downloadImageFromDataUrl(dataUrl, `${projectName}.png`);
}
